import React, { useEffect, useState } from 'react';
import { Table, Upload, Progress } from 'antd';
import uploadIcon from '../../assets/icons/upload-icon.svg';
import DownloadCsvIcon from '../../assets/icons/download-csv-icon.svg';
import Button from '../../components/Button/Button';
import csvIcon from '../../assets/icons/csv-icon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { bulkUploadFiles, bulkDownloadFiles } from '../../redux/internalOrderSlice/internalOrderSlice';
import { useRef } from 'react';
import { convertExceltoJson } from '../../utils/utilFunctions';
import { INTERNAL_ORDER_MASTER_BULK_UPLOAD, INTERNAL_ORDER_MASTER_BULK_DOWNLOAD } from '../../api/endpoints';

const UploadCSVFilesTable = (props) => {
        const { defaultData, uploadApi, downloadApi } = props;
        const fileInputRef = useRef(null);

        const dispatch = useDispatch();

        const [selectedFiles, setSelectedFiles] = useState([]);

        const [uploadStatus, setUploadStatus] = useState({});

        const { loading } = useSelector((state) => state.internalOrderMaster);

        const handleFileChange = async (event) => {
                const files = [...event.target.files];
                setSelectedFiles([...selectedFiles, ...files]);

                if (files.length > 0) {
                        await handleFileUpload(uploadApi, files);
                }

                event.target.value = '';
        };

        const handleFileUpload = async (apiUrl, filesToUpload = selectedFiles) => {
                const convertedJson = await convertExceltoJson(filesToUpload);

                let newObj = JSON.stringify(convertedJson);

                let dataObj = {
                        apiUrl,
                        newObj,
                };

                dispatch(bulkUploadFiles(dataObj));
        };

        const handleFileDownload = (apiUrl) => {
                dispatch(bulkDownloadFiles(apiUrl));
        };

        const columns = [
                {
                        title: 'Title',
                        dataIndex: 'title',
                        key: 'title',
                        width: 300,
                        align: 'center',

                        onCell: () => ({
                                style: {
                                        color: '#475467',
                                        fontWeight: '600',
                                        fontSize: '14px',
                                        fontStyle: 'inter',
                                },
                        }),
                },
                {
                        title: 'Download CSV Template',
                        key: 'download',
                        width: 300,
                        onCell: () => ({}),
                        render: (_, record) => (
                                <p className="flex justify-center">
                                        <Button
                                                text="Download CSV "
                                                icon={DownloadCsvIcon}
                                                onClick={() => handleFileDownload(downloadApi)}
                                        />
                                </p>
                        ),
                },
                {
                        title: 'Upload CSV',
                        key: 'upload',
                        width: 400,
                        align: 'center',

                        render: (_, record) => {
                                return (
                                        <div className="relative">
                                                <input
                                                        type="file"
                                                        onChange={handleFileChange}
                                                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                        className="hidden"
                                                        ref={fileInputRef}
                                                />

                                                <p>
                                                        <p>
                                                                <span
                                                                        className="text-[#6941C6] cursor-pointer font-semibold text-sm"
                                                                        onClick={() => fileInputRef.current.click()}>
                                                                        Browse
                                                                </span>
                                                                <span className="text-[#475467] text-sm font-inter font-normal"> or drag and drop</span>
                                                        </p>
                                                        <p className="text-[#475467] text-sm font-inter font-normal">CSV (max. Up to 50 MB)</p>
                                                </p>

                                                {selectedFiles.length > 0 && (
                                                        <div className="m-[0.25em] p-[0.25em]">
                                                                {selectedFiles.map((file) => (
                                                                        <p
                                                                                key={file.name}
                                                                                className="text-sm text-gray-600">
                                                                                {file.name} {loading ? '(Uploading...)' : '(Uploaded)'}
                                                                        </p>
                                                                ))}
                                                        </div>
                                                )}
                                        </div>
                                );
                        },
                },
        ];

        return (
                <div className="pt-12 pl-5 pr-4 pb-4">
                        <p className="pb-5"> Upload Files </p>
                        <Table
                                columns={columns}
                                dataSource={defaultData}
                                pagination={false}
                                bordered
                                className="custom-ant-table"
                        />
                </div>
        );
};

export default UploadCSVFilesTable;
